import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {push, goBack} from 'react-router-redux';
import AppBar from '@material-ui/core/AppBar';
import {Tabs, Tab} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import {ArrowBack as ArrowBackIcon} from '@material-ui/icons';
import {isEmpty} from 'lodash/lang';

class SecondaryNavigation extends React.Component {
  static propTypes = {
    hasBack: PropTypes.bool.isRequired,
    actions: PropTypes.node,
    tabs: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ),
  };

  static defaultProps = {
    hasBack: false,
  };

  constructor(props) {
    super(props);
    this.goTo = this.goTo.bind(this);
  }

  goTo(url) {
    const {push} = this.props;
    if (url.startsWith('/')) {
      push(url);
    } else {
      window.open(url, '_blank');
    }
  }

  render() {
    const {hasBack, actions, tabs, push, goBack} = this.props;
    let value;
    if (!isEmpty(tabs)) {
      for (const [idx, tab] of Object.entries(tabs)) {
        if (tab.isActive) {
          value = idx;
          break;
        }
      }
    }
    return (
      <div className="nav-secondary">
        <div className="action-list">
          {hasBack && (
            <IconButton onClick={goBack}>
              <ArrowBackIcon />
            </IconButton>
          )}
          {actions}
        </div>
        {!isEmpty(tabs) && (
          <AppBar position="static" color="secondary">
            <Tabs
              value={parseInt(value)}
              textColor="inherit"
              scrollButtons="auto"
              variant="scrollable"
              TabIndicatorProps={{
                style: {backgroundColor: '#fff'},
              }}
            >
              {tabs.map((tab, idx) => (
                <Tab key={tab.label} onClick={() => this.goTo(tab.url)} label={tab.label} value={parseInt(idx)} />
              ))}
            </Tabs>
          </AppBar>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  push: (...args) => dispatch(push(...args)),
  goBack: () => dispatch(goBack()),
});

export default connect(null, mapDispatchToProps)(SecondaryNavigation);
